import { gql } from '@apollo/client';

// --- External COM Queries ---

// List COM connections (RS232, etc.) for current account
// Fields include full COM config needed by RS232 Send dialog payload
export const EXTERNAL_COMS_QUERY = gql`
  query ExternalComs($first: Int, $after: String, $query: QueryExternalComInput) {
    externalComs(first: $first, after: $after, query: $query) {
      page {
        edges {
          cursor
          node {
            _id
            name
            path
            baudRate
            dataBits
            stopBits
            parity
            rtscts
            xon
            xoff
            eol
            encoding
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;

// List COM commands (saved RS232 commands) for current account
// Used by RS232 Send dialog "Commands" accordion section multi-select
export const COM_COMMANDS_QUERY = gql`
  query ComCommands($first: Int, $after: String) {
    comCommands(first: $first, after: $after) {
      page {
        edges {
          cursor
          node {
            _id
            name
            value
            eol
            encoding
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;

// List COM command templates
export const COM_COMMAND_TEMPLATES_QUERY = gql`
  query ComCommandTemplates($first: Int, $after: String, $query: QueryComCommandTemplateInput) {
    comCommandTemplates(first: $first, after: $after, query: $query) {
      page {
        edges {
          cursor
          node {
            _id
            name
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;
